import React from "react";
import { updateDelegates } from "../api/DelegateAPI";
import { retrieveDelegateAccess } from "../api/DelegateAPI";
import Slider from './Slider';
import { refreshAccessToken } from "../api/oauthAPI";

export default function FCUpdate(props) {
  function isNumber(num){
    return !isNaN(parseFloat(num)) && isFinite(num);
  }
  let identifier = props.searchValue;
  if (isNumber(identifier)) {
      identifier = identifier + ' - (' + props.fcResponse[0].eid + ')'
  }
  let fcName, fcEmail, fcPhone, fcAddress1, fcAddress2, fcCity, fcState, fcZip, compensationStatements, commissions, managementCompensation, variableManagementComp, currentAccess
  
  const firmContactEid = props.fcDisplayResponse.eid
  const firmEid = props.fcResponse[0].eid
  const singleFirmEid = firmEid.substring(0,9)
  let firmName = 'unknown'


  const firmEidList = firmEid.split(',');

  if (props.fcResponse[0].name) {
      firmName = props.fcResponse[0].name.lastName
  }

  if(props.fcDisplayResponse.name !== null && props.fcDisplayResponse.name !== undefined) {
      fcName = props.fcDisplayResponse.name.firstName + ' ' + props.fcDisplayResponse.name.middleName + ' ' + props.fcDisplayResponse.name.lastName + ' ' + props.fcDisplayResponse.name.suffix
  }

  if(props.fcDisplayResponse.emailAddressList !== null && props.fcDisplayResponse.emailAddressList !== undefined && props.fcDisplayResponse.emailAddressList.length !== 0) {
      fcEmail = props.fcDisplayResponse.emailAddressList[0].email
  }

  if(props.fcDisplayResponse.phoneNumberList !== null && props.fcDisplayResponse.phoneNumberList !== undefined && props.fcDisplayResponse.phoneNumberList.length !== 0) {
      fcPhone = props.fcDisplayResponse.phoneNumberList[0].areaCode +  ' ' + props.fcDisplayResponse.phoneNumberList[0].number
  }

  if(props.fcDisplayResponse.postalAddressList !== null && props.fcDisplayResponse.postalAddressList !== undefined && props.fcDisplayResponse.postalAddressList.length !== 0) {
      fcAddress1 = props.fcDisplayResponse.postalAddressList[0].addressLine1
  }

  if(props.fcDisplayResponse.postalAddressList !== null && props.fcDisplayResponse.postalAddressList !== undefined && props.fcDisplayResponse.postalAddressList.length !== 0) {
      fcAddress2 = props.fcDisplayResponse.postalAddressList[0].addressLine2
  }

  if(props.fcDisplayResponse.postalAddressList !== null && props.fcDisplayResponse.postalAddressList !== undefined && props.fcDisplayResponse.postalAddressList.length !== 0) {
      fcCity = props.fcDisplayResponse.postalAddressList[0].city
  }

  if(props.fcDisplayResponse.postalAddressList !== null && props.fcDisplayResponse.postalAddressList !== undefined && props.fcDisplayResponse.postalAddressList.length !== 0) {
      fcState = props.fcDisplayResponse.postalAddressList[0].state
  }

  if(props.fcDisplayResponse.postalAddressList !== null && props.fcDisplayResponse.postalAddressList !== undefined && props.fcDisplayResponse.postalAddressList.length !== 0) {
      fcZip = props.fcDisplayResponse.postalAddressList[0].zipCode
  }


  currentAccess = convertAccountCodetoBoolean(props.fcDisplayResponse.delegateAccess.accountAccess.currentAccess)
  for (let i = 0; i < props.fcDisplayResponse.delegateAccess.applicationAccess.length; i++) {
    if (props.fcDisplayResponse.delegateAccess.applicationAccess[i].number === "2"){
        compensationStatements = props.fcDisplayResponse.delegateAccess.applicationAccess[i].access;
    } else if (props.fcDisplayResponse.delegateAccess.applicationAccess[i].number === "3"){
        commissions = props.fcDisplayResponse.delegateAccess.applicationAccess[i].access;
    } else if (props.fcDisplayResponse.delegateAccess.applicationAccess[i].number === "4"){
        managementCompensation = props.fcDisplayResponse.delegateAccess.applicationAccess[i].access;
    } else if (props.fcDisplayResponse.delegateAccess.applicationAccess[i].number === "5"){
        variableManagementComp = props.fcDisplayResponse.delegateAccess.applicationAccess[i].access;
    }
}

  function returnToFcList() {
    props.setFcEditMode(false)
    props.setGlobalAlert(
      {
        hidden: true,
      }
    )
  }
  function convertAccountCodetoBoolean(input) {
    if(input === 'A') {
      return true;
    } else {
      return false;
    }
  }
  function convertBooleanToAccessCode(input) {
    if(input) {
      return "1";
    } else {
      return "2";
    }
  }

  async function submitFirmEdit() {

    props.setSpinnerActive(true)
    document.getElementById("submitEditFirmButton").disabled=true
    let newAcctAccess = 'N'
    if (document.getElementById("accountAccessUpdateAll").checked) {
        newAcctAccess = 'A'
    }
    let compensation = document.getElementById('compensationUpdateYes').checked
    let commission = document.getElementById('commissionUpdateYes').checked
    let mgmtcomp = document.getElementById('managementCompensationUpdateYes').checked
    let varmgmt = document.getElementById('variablemanagementUpdateYes').checked
    document.getElementById('pds-datatable-accessUpdate').hidden = true

    let token = props.user.access_token
    if (props.user.expired) {
      token = await refreshAccessToken(props.user.refresh_token)
    }

    for (let i = 0; i < firmEidList.length; i++) {
      let request = {
        dpEid: firmEidList[i].trim(),
        appIdentifier: 'FirmContact',
        userEid: props.userEid,
        csrEid: props.userEid,
        delegates: [
          {
            eid: firmContactEid,
            appAccessList: [
              {
                appTypeText: null,
                appTypeCode: '2',
                dlgtAccessCode: convertBooleanToAccessCode(compensation)
              },
              {
                appTypeText: null,
                appTypeCode: '3',
                dlgtAccessCode: convertBooleanToAccessCode(commission)
              },
              {
                appTypeText: null,
                appTypeCode: '4',
                dlgtAccessCode: convertBooleanToAccessCode(mgmtcomp)
              },
              {
                appTypeText: null,
                appTypeCode: '5',
                dlgtAccessCode: convertBooleanToAccessCode(varmgmt)
              }
            ],
            accountAccess: {
              currentAccess: newAcctAccess,
              futureAccess: newAcctAccess,
              accounts: null
            }
          }
        ]
      }

      let resp = await updateDelegates(token, request)

      if ((resp.status != null) && (resp.status === 200 || resp.status === 204)) {
        props.setGlobalAlert(
          {
            id: "success-update",
            type: "success",
            message:
              "Firm Contact updated",
            hidden: false,
          }
        )
      } else {
        props.setGlobalAlert(
          {
            id: "error-update",
            type: "error",
            message:
              "Firm Contact update failed",
            hidden: false,
          }
        )
      }
    }

    let resp = null;
    if(firmContactEid !== null && firmContactEid !== undefined && firmEid !== null && firmEid !== undefined) {
      resp= await retrieveDelegateAccess(token, singleFirmEid, firmContactEid)
    }
      props.setFcDisplayResponse(resp)
      props.setFcEditMode(false)
      props.setSpinnerActive(false)

  }

  return (
    <div>   
      
      <h3>Firm Information</h3>
            <strong>Firm Name:</strong> {`${firmName}`} <br></br>
            <strong>Firm Identifier:</strong> {`${identifier}`} <br></br>
            <h3>Firm Contact Information</h3>
            <table>
              <tbody>
                <tr>
                    <td className="col-8">
                        <strong>Firm Contact EID : </strong> {`${firmContactEid}`} 
                    </td>
                    <td className="col-8">
                        <strong>Line 1 Address : </strong> {`${fcAddress1}`} 
                    </td>
                </tr>
                <tr>
                    <td className="col-8">
                    <strong>Firm Contact Name : </strong> {`${fcName}`}
                    </td>
                    <td className="col-8">
                    <strong>Line 2 Address : </strong> {`${fcAddress2}`} 
                    </td>
                </tr>
                <tr>
                    <td className="col-8">
                    <strong>Email Address : </strong> {`${fcEmail}`} 
                    </td>
                    <td className="col-8">
                    <strong>City : </strong> {`${fcCity}`} 
                    </td>
                </tr>
                <tr>
                    <td className="col-8">
                    <strong>Phone Number : </strong>  {`${fcPhone}`}
                    </td>
                    <td className="col-8">
                    <strong>State : </strong> {`${fcState}`}
                    </td>
                </tr>
                <tr>
                    <td className="col-8">
                    </td>
                    <td className="col-8">
                    <strong>ZIP Code : </strong> {`${fcZip}`} <br></br><br></br>
                    </td>
                </tr>
              </tbody>
            </table>
                <table
        className="pds-table pds-table-bordered"
        id='pds-datatable-accessUpdate'
        aria-live="polite">
        <tbody>
          <tr>
            <td>
              <strong>Compensation Statement Access : </strong> <br></br>
              <div className="pds-segmentedControl">
                <Slider name="compensationOption" id="compensationUpdateYes" value="Yes" selected={compensationStatements}></Slider>
                <Slider name="compensationOption" id="compensationUpdateNo" value="No" selected={!compensationStatements}></Slider>
              </div>
            </td>
            <td>
              <strong>Account Access : </strong><br></br>
              <div className="pds-segmentedControl">
                <Slider name="accountAccessOption" id="accountAccessUpdateAll" value="All" selected={currentAccess}></Slider>
                <Slider name="accountAccessOption" id="accountAccessUpdateNone" value="None" selected={!currentAccess}></Slider>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <strong>Commissions Access : </strong> <br></br>
              <div className="pds-segmentedControl">
                <Slider name="commissionOption" id="commissionUpdateYes" value="Yes" selected={commissions}></Slider>
                <Slider name="commissionOption" id="commissionUpdateNo" value="No" selected={!commissions}></Slider>
              </div>
            </td>
            <td></td>
          </tr>
          <tr>
            <td>
              <strong>Management Compenesation Access : </strong> <br></br>
              <div className="pds-segmentedControl">
                <Slider name="managementCompensationOption" id="managementCompensationUpdateYes" value="Yes" selected={managementCompensation}></Slider>
                <Slider name="managementCompensationOption" id="managementCompensationUpdateNo" value="No" selected={!managementCompensation}></Slider>
              </div>
            </td>
            <td></td>
          </tr>
          <tr>
            <td>
              <strong>Variable Management Access : </strong> <br></br>
              <div className="pds-segmentedControl">
                <Slider name="variablemanagementOption" id="variablemanagementUpdateYes" value="Yes" selected={variableManagementComp}></Slider>
                <Slider name="variablemanagementOption" id="variablemanagementUpdateNo" value="No" selected={!variableManagementComp}></Slider>
              </div>
            </td>
            <td></td>
          </tr>
        </tbody>
      </table>
      <br></br>
      <button
          className="pds-button pds-button-primary"
          data-gtm="modal-cta"
          id ="submitEditFirmButton"
          onClick={submitFirmEdit}  
          >
          Submit Update
      </button>
      &nbsp;
      <button
          className="pds-button pds-button-secondary"
          data-gtm="modal-cta"
          id ="firmFcListButton"
          onClick={returnToFcList}  
          >
          Cancel
      </button>
    </div>
  );
}